function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Segment } from '@signicat/designi/components/containers';
import { Select } from '@signicat/designi/components/inputs';
import { Button } from '@signicat/designi/components/buttons';
import { module as moduleActions } from "../../store/actions";
import { currentStackSelector } from "../../store/selectors/module";
var DeveloperSettings = function DeveloperSettings() {
  var dispatch = useDispatch();
  var stacks = useSelector(function (state) {
    return state.module.stacks;
  });
  var currentStack = useSelector(currentStackSelector);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    clearCacheStatus = _useState2[0],
    setClearCacheStatus = _useState2[1];
  var handleStackChange = function handleStackChange(e) {
    var stack = e.target.value;
    dispatch({
      type: 'SET_SETTINGS',
      key: 'stack',
      value: stack
    });
  };
  var handleClearCacheClick = function handleClearCacheClick() {
    dispatch(moduleActions.clearCache()).then(function () {
      setClearCacheStatus('Cache was cleared');
    })["catch"](function (err) {
      setClearCacheStatus('An error occurred while clearing cache');
    });
  };
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Segment, {
    outlined: true
  }, "Select default language", /*#__PURE__*/React.createElement(Select, {
    options: Object.keys(stacks).map(function (s) {
      return {
        value: s,
        text: s
      };
    }),
    value: currentStack,
    onChange: handleStackChange
  })), /*#__PURE__*/React.createElement(Segment, {
    outlined: true
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClearCacheClick
  }, "Clear signature module cache"), clearCacheStatus));
};
export default DeveloperSettings;